import { DialogTitle } from "@material-ui/core";
import Dialog from "@material-ui/core/Dialog";
import IconButton from "@material-ui/core/IconButton";
import Slide from "@material-ui/core/Slide";
import { makeStyles } from "@material-ui/core/styles";
import ArrowBackRoundedIcon from "@material-ui/icons/ArrowBackRounded";
import React from "react";
import "./FormDialog.css";
const useStyles = makeStyles((theme) => ({
  appBar: {
    position: "relative",
  },
  title: {
    marginLeft: theme.spacing(2),
    flex: 1,
  },
}));
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});
export default function FullScreenDialog(props) {
  const classes = useStyles();
  const HiddenCloseIcon = !props.HiddenCloseIcon
    ? false
    : props.HiddenCloseIcon;
  return (
    <div>
      <Dialog
        disableBackdropClick={props.disableBackdropClick}
        fullWidth={props.fullWidth || false}
        maxWidth={props.maxWidth}
        fullScreen={props.fullScreen}
        scroll={props.scroll || "paper"}
        open={props.open}
        onClose={props.handleClose}
        TransitionComponent={Transition}
      >
        {HiddenCloseIcon === false && (
          <DialogTitle
            id="form-dialog-title"
            style={{ paddingBottom: 0, minWidth: 250 }}
          >
            <IconButton
              edge="start"
              color="inherit"
              onClick={props.handleClose}
              aria-label="close"
              style={{
                backgroundColor: "rgba(0,0,0,0.6)",
                color: "#ffffff",
              }}
            >
              <ArrowBackRoundedIcon />
            </IconButton>
          </DialogTitle>
        )}
        {props.children}
      </Dialog>
    </div>
  );
}
